import React from 'react';
import PropTypes from 'prop-types';

import styles from '../Filter.scss';


function FormRow(props) {
    const { label, children, required } = props;

    let labelClassName = 'label-text';

    if (required) {
        labelClassName += '-required';
    }
    return (
        <div className={styles['form-row']}>
            <div className={styles['form-item-stacked']}>
                <div className={styles['form-label']}>
                    <span className={styles[labelClassName]}>
                        {label}
                        :
                    </span>
                </div>
                <div className={styles['form-field']}>
                    {children}
                </div>
            </div>
        </div>
    );
}

FormRow.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    required: PropTypes.bool,
};

FormRow.defaultProps = {
    required: false,
};

export default FormRow;
